import { gozokiAiApi } from '../gozokiApi';

export const deleteAnomaly = async (storeId: string, anomalyId: string) => {
    const response = await gozokiAiApi.delete(`/stores/${storeId}/alerts/${anomalyId}`);
    return response;
};
